import { MESSAGE_DEFAULT, MESSAGE_FULFILLED, MESSAGE_REJECTED, MESSAGE_CLEAR } from "../actions/redux/messageActionTypes";

const defaultData = {
    "loanSearchForm_RequiredEntryCertOrLLN": "Please enter either a certificate/commitment number, or a lender loan number.",
    "loanSearchForm_RequiredEntryLastName": "Please enter a last name.",
    "loanSearchForm_NoResultsFound": "No cert found",
    "loanResult_StatusNoteSubErrorDelegated": "Please contact EssentConnect by emailing essentconnectsupport@essent.us or calling 833.ESNT4MI (833.376.8464).",
    "loanResult_StatusNoteSubErrorNonDelegated": "Please contact EssentConnect by emailing essentconnectsupport@essent.us or calling 833.ESNT4MI (833.376.8464).",
    "loanResult_StatusNoteClosed": "Please contact Client Services for additional information at 877-569-6547."
  };

const initialState = defaultData;

const MessageReducer = (state = initialState, action) => {
    switch(action.type){
        case MESSAGE_DEFAULT:
            return {
                ...state,
                messages: defaultData
            };

        case MESSAGE_CLEAR:
            return {
                ...state,
                messages: defaultData
            };
        case MESSAGE_REJECTED: 
            return {
                ...state,
                messages: defaultData
            };
            
        case MESSAGE_FULFILLED:
            return {
                ...state,
                messages: action?.payload
            };

        default: return state
    }
}


export {
    MessageReducer,
} 